import React, { useEffect, useState } from "react";
import AddQuestion from "../../Modals/AddQuestion";
import { Link } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import {
    create_faq_question,
    get_all_faq_questions,
    get_faq_data,
    update_items_sequence,
} from "../../reduxData/cms/cmsAction";
import EmptyData from "../../components/EmptyData";
import { GET_EDIT_DATA } from "../../reduxData/cms/cmsTypes";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import DeleteContent from "../../Modals/DeleteContent";
import ReactQuill from "react-quill";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const FAQNL = ({ user, faqItems, faqcontent }) => {
    const { t } = useTranslation();
    const [isShow, setIsShow] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [editdata, setEditdata] = useState(null);
    const dispatch = useDispatch();
    const { userPermissions } = useSelector((state) => state.auth);
    const [currentQuest, setCurrentQuest] = useState("seller-nl");
    const canEditCms = userPermissions?.cms?.edit === true;
    const canToggleCms = userPermissions?.cms?.delete === true;

    // text editor features 
    const modules = {
        toolbar: [
            [{ font: [] }, { size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
            [{ script: "sub" }, { script: "super" }],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }, { align: [] }],
            [{ color: [] }, { background: [] }],
            ["link", "image", "video"],
            ["clean"],
            [{ undo: "undo" }, { redo: "redo" }],
        ],
        history: { delay: 1000, maxStack: 100, userOnly: true },
    };

    const [faqContent, setFaqContent] = useState("");
    const [faqStatus, setFaqStatus] = useState(false);

    // handle faq dutch introduction content value change 
    const handleQuillChange = (value) => {
        setFaqContent(value);
    };

    // hanlde faq dutch introduction content active deactive 
    const handleFaqStatus = (e) => {
        setFaqStatus(e.target.checked);
    };

    const isQuillEmpty = (html) => {
        if (!html) return true;
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent.trim() === "";
    };

    // handle faq dutch introduction data submit 
    const handleSubmit = async () => {
         const contentError = isQuillEmpty(faqContent);

        // if (!faqContent || faqContent === "<p><br></p>" || faqContent.trim() === "") {
        //     toast.error(t("cms.validation.contentRequired"), { autoClose: 1500 });
        //     return;
        // }

        if (contentError) {
            toast.error(t("cms.validation.contentRequired"), { autoClose: 1500 });
            return;
        }

        const quest_data = {
            name: "faqContent_nl",
            type: "faqContent_nl",
            status: faqStatus,
            content: { content: faqContent },
        };
        const contentId = faqcontent ? faqcontent?.id : null;
        await create_faq_question(quest_data, contentId, dispatch);
    };

    // fetch dutch faq content

    useEffect(() => {
        const saved = localStorage.getItem("currentQuest");
        if (saved) {
            const parsed = JSON.parse(saved);
            const dutchType = parsed.includes("-nl") ? parsed : `${parsed}-nl`;
            setCurrentQuest(dutchType);
            localStorage.setItem("currentQuest", JSON.stringify(dutchType));
        } else {
            setCurrentQuest("seller-nl");
            localStorage.setItem("currentQuest", JSON.stringify("seller-nl"));
        }
    }, []);

    useEffect(() => {
        const handleQuest = async () => {
            await get_all_faq_questions(currentQuest, dispatch);
        };
        handleQuest();
    }, [currentQuest]);

    // update question sequence 
    const handleDragEnd = async (result) => {
        if (!canEditCms || !result.destination) return;
        const items = Array.from(faqItems);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        const updated_sequence = {
            sequence: items.map((item) => item._id),
        };
        const updated = await update_items_sequence(updated_sequence, currentQuest);
        if (updated) {
            await get_all_faq_questions(currentQuest, dispatch);
        }
    };

    const handleToogle = async (status, item) => {
        const quest_data = {
            name: "FAQ",
            type: item.type,
            status: item.status === true ? false : true,
            content: {
                question: item?.content?.question,
                answer: item?.content?.answer,
            }
        };
        let question_created = await create_faq_question(quest_data, item?.id, dispatch);
        if (question_created) {
            await get_all_faq_questions(currentQuest, dispatch);
        }
    };


    return (
        <div className="mt-1">
            <div className="container">
                <h3 className="fw-500">{t("cms.faqNl.title")}</h3>
                <div className="mb-5">
                    <h5>{t("cms.faqNl.introContent")} *</h5>
                    <div className="col-12 mb-3">
                        <ReactQuill
                            value={faqContent}
                            modules={modules}
                            disabled={!canEditCms}
                            onChange={handleQuillChange}
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <div className="form-check form-switch switch-large">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={faqStatus}
                                disabled={!canToggleCms}
                                onChange={handleFaqStatus}
                            />
                            <label className="form-check-label">{t("cms.common.status")}</label>
                        </div>
                    </div>
                    {canEditCms && (
          <Button
                        className="btn common-button"
                        
                        onClick={handleSubmit}
                    >
                        {t("cms.faqNl.saveContent")}
                    </Button>
          )}
                </div>

                {/* Tabs */}
                <div className="d-flex justify-content-between">
                    <div className="col-lg-4 col-md-6 pt-2">
                        <ul className="list-inline mb-0 sorting-list">
                            <li className="list-inline-item mb-2 mb-md-0">
                                <Link
                                    className={`text-decoration-none border rounded-pill px-3 py-2 ${currentQuest === "seller-nl" ? "active" : ""
                                        }`}
                                    onClick={() => {
                                        setCurrentQuest("seller-nl");
                                        localStorage.setItem("currentQuest", JSON.stringify("seller-nl"));
                                    }}
                                >
                                    {t("cms.faqNl.seller")}
                                </Link>
                            </li>
                            <li className="list-inline-item mb-2 mb-md-0">
                                <Link
                                    className={`text-decoration-none border rounded-pill px-3 py-2 ${currentQuest === "buyer-nl" ? "active" : ""
                                        }`}
                                    onClick={() => {
                                        setCurrentQuest("buyer-nl");
                                        localStorage.setItem("currentQuest", JSON.stringify("buyer-nl"));
                                    }}
                                >
                                    {t("cms.faqNl.buyer")}
                                </Link>
                            </li>
                        </ul>
                    </div>
                    {canEditCms && (
                    <button
                        className="btn common-button"
                        
                        onClick={() => setIsShow(true)}
                    >
                        {t("cms.faqNl.addQuestion")}
                    </button>
                    )}
                </div>

                <div className="col-lg-12 mt-2">
                    <h5 className="fw-500">
                        {currentQuest === "seller-nl" ? t("cms.faqNl.seller") : t("cms.faqNl.buyer")} {t("cms.faqNl.questions")}
                    </h5>
                    <div className="table-responsive mt-4">
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <Droppable droppableId="faqlist">
                                {(provided) => (
                                    <table
                                        className="table table-hover user-management-table"
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        <thead className="border-gray">
                                            <tr>
                                                <th>#</th>
                                                <th>{t("cms.faqNl.question")}</th>
                                                <th>{t("cms.common.status")}</th>
                                                {(canEditCms || canToggleCms) && <th>{t("cms.faqNl.action")}</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {faqItems?.length > 0 ?
                                                faqItems?.map((item, index) => (
                                                    <Draggable key={item?._id} draggableId={item?._id} index={index}>
                                                        {(provided) => (
                                                            <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                <td>{index + 1}.</td>
                                                                <td>{item?.content?.question}</td>
                                                                <td>
                                                                    <div className="form-check form-switch switch-large">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            role="switch"
                                                                            id="flexSwitchCheckDefault"
                                                                            checked={item?.status}
                                                                            disabled={!canToggleCms}
                                                                            onChange={(e) => handleToogle(e.target.value, item)}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                {(canEditCms || canToggleCms) && <td className="d-flex pt-4">
                                                                    {canEditCms && (
                                                                        <div onClick={() => { dispatch({ type: GET_EDIT_DATA, payload: item }); setIsShow(true); }}>
                                                                            <i className="cursor-pointer mx-2 far fa-edit edit" />
                                                                        </div>
                                                                    )}
                                                                    {canToggleCms && (
                                                                        <div>
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="16"
                                                                                height="16"
                                                                                fill="currentColor"
                                                                                viewBox="0 0 16 16"
                                                                                className="cursor-pointer delete-icon bi bi-trash3-fill"
                                                                                onClick={() => { setEditdata(item); setIsDelete(true); }}
                                                                            >
                                                                                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                                                                            </svg>
                                                                        </div>
                                                                    )}
                                                                </td>}
                                                            </tr>
                                                        )}
                                                    </Draggable>
                                                ))
                                                :
                                                <EmptyData />
                                            }
                                        </tbody>
                                    </table>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
            </div>

            <AddQuestion
                show={isShow}
                handleClose={() => {
                    dispatch({ type: GET_EDIT_DATA, payload: null });
                    setIsShow(false);
                }}
                isDutch={true}
            />

            <DeleteContent
                show={isDelete}
                handleClose={() => {
                    setEditdata(null);
                    setIsDelete(false);
                }}
                data={editdata}
                heading={t("cms.faqNl.deleteQuestion")}
                otherLine={editdata?.content?.question || t("cms.faqNl.thisQuestion")}
                isFaq={true}
                currentQuest={currentQuest}
                onSuccess={() => {
                    get_all_faq_questions(currentQuest, dispatch);
                }}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    user: state.auth.user,
    faqItems: state.cms.faqItemsnl,
    faqcontent: state.cms.faqContentnl,
});

export default connect(mapStateToProps)(FAQNL);
